<template>
  <div class="home">
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in detail.banner" :key="index">
        <a :href="image.linkurl" :target="index"
          ><img v-lazy="image.imageurl"
        /></a>
      </van-swipe-item>
    </van-swipe>
    <!-- 首页播报&&资讯 -->
    <div class="homeMidO">
      <div style="display:flex;margin-bottom:0.6rem">
        <div class="homeMidOl">
          <div class="homeTit">
            <van-image
              width="7.5rem"
              height="2.0625rem"
              lazy-load
              :src="require('../assets/youbeibobao@2x.png')"
              @click="toybbb(detail.ybbb.id)"
            />
            <!-- <div class="share">
              <ul>
                分享到
                <li>
                  <img @click="shareToWeibo" src="../assets/weibo.png" alt="" />
                </li>
                <li class="weiXin">
                  <img src="../assets/weixin.png" alt="" />
                </li>
                <div class="qrcode" ref="qrCodeUrl">
                  <div class="shareIn">微信扫一扫 分享到朋友圈</div>
                </div>
                <li>
                  <img
                    @click="shareToQQkj"
                    src="../assets/qqkongjian.png"
                    alt=""
                  />
                </li>
              </ul>
            </div> -->
          </div>
          <div style="cursor:pointer;position:relative">
            <video
              x5-playsinline="true"
              playsinline="true"
              webkit-playsinline="true"
              id="video1"
              ref="videoid"
              controlsList="nodownload"
              @contextmenu.prevent
              style="width:44rem;height:25.3125rem"
              preload="auto"
              :poster="detail.ybbb.video_cover"
              controls="controls"
            >
              <source :src="detail.ybbb.video_url" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="homeMidOR">
          <div class="homeTit">
            <van-image
              width="7.5rem"
              height="2.0625rem"
              lazy-load
              :src="require('../assets/youbeizixun@2x.png')"
              @click="toZx()"
            />
          </div>
          <div class="homeZx">
            <ul class="homeZxLout">
              <li
                class="homeZxL"
                v-for="(item, index) in detail.ybzx"
                :key="index"
                @click="toZxDetail(item.id)"
              >
                <p>{{ item.title }}</p>
                <!-- <p>{{item.brief_introduction}}</p> -->
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="detail.ad_01[0]" class="homAdv">
        <a target="view_frame1" :href="detail.ad_01[0].linkurl">
          <van-image
            width="75rem"
            height="6.25rem"
            lazy-load
            :src="detail.ad_01[0].imageurl"
          />
        </a>
      </div>
    </div>
    <!-- 首页商城 -->
    <div class="homeMidO">
      <div class="homeVidTop tabTs">
        <van-tabs
          v-model="active2"
          title-active-color="#F06F25"
          color="rgba(255, 94, 4, 1)"
          line-height=".125rem"
          line-width=".3125rem"
        >
          <van-tab to="ShopIndex" title="商城"></van-tab>
          <van-tab to="ShopIndex" disabled title="门票"></van-tab>
          <van-tab to="ShopIndex" disabled title="线路"></van-tab>
          <van-tab to="ShopIndex" disabled title="特产"></van-tab>
          <!-- <van-tab to="HomeTuijian" title="专题"></van-tab> -->
        </van-tabs>
      </div>
      <router-view name="location3" :msg="detail" />
      <div v-if="detail.ad_02[0]" class="homAdv">
        <a target="view_frame3" :href="detail.ad_02[0].linkurl">
          <van-image
            width="75rem"
            height="6.25rem"
            lazy-load
            :src="detail.ad_02[0].imageurl"
          />
        </a>
      </div>
    </div>
    <!-- 首页视频 -->
    <div class="homeMidO">
      <div class="homeVidTop">
        <van-tabs
          v-model="active1"
          title-active-color="#F06F25"
          color="rgba(255, 94, 4, 1)"
          line-height=".125rem"
          line-width=".3125rem"
        >
          <van-tab to="HomeVideo" title="视频"></van-tab>
          <van-tab to="ARVideo" title="全景"></van-tab>
        </van-tabs>
      </div>
      <router-view @change2="tabChange2" name="location1" :msg="detail" />
      <div v-if="detail.ad_03[0]" class="homAdv">
        <a target="view_frame2" :href="detail.ad_03[0].linkurl">
          <van-image
            width="75rem"
            height="6.25rem"
            lazy-load
            :src="detail.ad_03[0].imageurl"
          />
        </a>
      </div>
    </div>

    <!-- 首页推荐 -->
    <div class="homeMidO">
      <div class="homeVidTop">
        <van-tabs
          v-model="active2"
          title-active-color="#F06F25"
          color="rgba(255, 94, 4, 1)"
          line-height=".125rem"
          line-width=".3125rem"
        >
          <van-tab to="HomeRec" title="推荐"></van-tab>
          <van-tab to="HomeTuijian" title="专题"></van-tab>
        </van-tabs>
      </div>
      <router-view @change2="tabChange2" name="location2" :msg="detail" />
      <div v-if="detail.ad_04[0]" class="homAdv">
        <a target="view_frame3" :href="detail.ad_04[0].linkurl">
          <van-image
            width="75rem"
            height="6.25rem"
            lazy-load
            :src="detail.ad_04[0].imageurl"
          />
        </a>
      </div>
    </div>
    <!-- 首页美图 -->
    <div class="homeMidO">
      <div class="homeTit">
        <van-image
          width="4.5rem"
          height="2.065rem"
          lazy-load
          :src="require('../assets/meitu@2x.png')"
          @click="toMt()"
        />
      </div>
      <ul class="mtListOut" style="display:flex">
        <li
          class="mtList"
          v-for="(item, index) in detail.tj"
          :key="index"
          @click="toSeeImg(item.id)"
        >
          <van-image
            width="17rem"
            height="11.75rem"
            lazy-load
            :src="item.imageurl"
          />
          <div class="mtName">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
    <div class="homeMidO">
      <div class="homeTit">
        <van-image
          width="6.5rem"
          height="2.065rem"
          lazy-load
          :src="require('../assets/yqlj.png')"
        />
      </div>
      <ul class="yqljOut">
        <li class="yqljList" v-for="(item, index) in detail.link" :key="index">
          <a :href="item.linkurl" :target="'yq' + index">{{ item.title }}</a
          >|
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { postHome } from "../utils/requerst/requerst";
import { UrlSearch } from "../utils/util";
export default {
  data() {
    return {
      active1: 0,
      active2: 0,
      images: [
        "https://img.yzcdn.cn/vant/apple-1.jpg",
        "https://img.yzcdn.cn/vant/apple-2.jpg"
      ],
      detail: ""
    };
  },
  created() {
    postHome().then(res => {
      this.detail = res.data;
      console.log(this.detail);
      console.log(this.detail.ybbb.video_cover);

      this.$nextTick(function() {
        this.creatQrCode();
      });
    });
  },
  methods: {
    //生成二维码
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: "https://yooobei.com/#/Broadcast", // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    shareToQQkj() {
      //分享到QQ空间(可用)
      var detail = this.detail.ybbb;
      const share = {
        title: detail.title,
        desc: detail.brief_introduction,
        image_url: [detail.img1],
        share_url: "https://yooobei.com/#/Broadcast"
      };
      let image_urls = share.image_url.map(function(image) {
        return encodeURIComponent(image);
      });
      //跳转地址
      window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pics=" +
          image_urls.join("|") +
          "&summary=" +
          share.desc
      );
    },
    //分享到微博(可用)
    shareToWeibo() {
      var detail = this.detail.ybbb;
      //自定义内容
      const share = {
        title: detail.title,
        image_url: [detail.img1],
        share_url: "https://yooobei.com/#/Broadcast"
      };
      //跳转地址
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"
      );
    },
    toMt() {
      window.open("https://yooobei.com/#/Mito");
    },
    toZx() {
      window.open("https://yooobei.com/#/Information");
    },
    toZxDetail(id) {
      window.open("https://yooobei.com/#/InfDetail?id=" + id);
    },
    toybbb(id) {
      window.open("https://yooobei.com/#/Broadcast?id=" + id);
    },
    toSeeImg(id) {
      window.open("https://yooobei.com/#/MitoDetail?id=" + id);
    },
    // 切换tab
    tabChange2: function(num) {
      this.$emit("change", num);
    }
  }
};
</script>

<style lang="stylus">
p,h6{
  margin 0
  padding 0

}




img {
  display block
}
.van-swipe img{
  width: 100%;
  height: 23.75rem;
}
.homeTit{
  margin 1.25rem 0
  cursor pointer
  display flex
  justify-content space-between
}


.bfq{
  width 2.75rem
  height 2.75rem
  position absolute
  right .8125rem
}
.bfq1{
  bottom .8125rem
}


.homAdv{
  padding  0
}
.homeMidO{
  width 75rem
  margin 0 auto
}
.homeMidOR{
  margin-left 1.9375rem
  flex 1

}
.homeZxLout{
  height 22.5rem
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.homeZxL{
  // border-bottom 1px solid #E9E6EA
  padding 0 0 .75rem 0
  cursor:pointer
}

.homeZxL h6{
  font-size 1.5rem;
  font-weight:bold;
  // color:rgba(51,51,51,1);
  line-height:2.25rem;
  width 27.8125rem

}
.homeZxL p{
  // font-size:1rem;
  font-weight:500;
  color:rgba(102,102,102,1);
  line-height:1.1rem;
  height 1.1rem
  width 27.8125rem
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.homeZxLout li:nth-child(1) p,.homeZxLout li:nth-child(4) p,.homeZxLout li:nth-child(7) p,.homeZxLout li:nth-child(10) p{
  font-size 1.25rem !important
  font-weight:bold;
  color #000
  line-height:1.75rem;
  height 1.9rem
  margin-top 0
}
.homeZxLout li:hover p{
  color rgba(255, 94, 4, 1)
}


// 视频
.homeVidTop{
  padding-right  86%
  padding-top .625rem
  border-bottom  1px solid rgba(255, 94, 4, 1)
}
.tabTs{
  padding-right 72%
}
.homeVidTop .van-tab__text{
  font-size:1.2rem;
  font-weight:400;
  line-height:.75rem;
}
.homeVidTop [class*=van-hairline]::after{
  border none
}




// 美图
.mtListOut{
  display flex
  // justify-content space-around
  margin-bottom 1.75rem
}
.mtList{
  position relative
  margin-right 2.1875rem
}
.mtName{
  width 17rem
  height 1.875rem
  position absolute
  left 0
  bottom .25rem
  background:rgba(0,0,0,0.3);
  font-size:1rem;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height 1.875rem;
  text-align center
}
.mtName:hover{
  background rgba(255, 94, 4, 1)
  cursor:pointer
}

.yqLj{
  width: 100px;
  background: #ddd;
  border-bottom: 0;
  line-height: 35px;
  color: #535758;
  text-align center
}
.yqljOut{
    width 100%
    color: #d7d7d7;
    font-size: .75rem;
    line-height: 1.5625rem;
    margin-bottom: 1.25rem;
    padding: 1.25rem 1.875rem;
    overflow: hidden;
    border: 1px solid #dddddd;
    box-sizing border-box
    display flex
    flex-wrap wrap
}
.yqljList{
    color: #999999;
    margin: 0 .3125rem;
    text-decoration: none;
}
.yqljList a{
  margin-right 0.5rem
  color #666
}

video::-webkit-media-controls-fullscreen-button {
  display:none !important;
}

// video::-internal-media-controls-download-button {
//   display:none !important;
// }
// video::-webkit-media-controls-enclosure {
//   overflow:hidden !important;
// }
// video::-webkit-media-controls-panel {
//   width: calc(100% + 30px);
// }
</style>
